
import Vue from "vue";
import { mapState } from "vuex";
import { User } from "@/api/users";

export interface UserDlgSelection {
  selectedAssigneeRef: string;
  confirm: boolean;
}
// eslint-disable-next-line
const ConfirmDlgUser: any = Vue.extend({
  name: "ConfirmDlgUser",
  props: {
    labelOk: {
      type: String,
      default: "OK",
    },
    labelCancel: {
      type: String,
      default: "Abbruch",
    },
  },
  data() {
    return {
      dialog: false,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      resolve: (v: UserDlgSelection) => {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      reject: (v: UserDlgSelection) => {},
      message: "",
      title: "",
      options: {
        textColor: "grey lighten-3",
        width: 400,
        zIndex: 200,
        noconfirm: false,
        textOk: this.labelOk,
        textCancel: this.labelCancel,
        currentAssignee: "",
      },
    };
  },
  computed: {
    ...mapState("user", ["users"]),
  },
  methods: {
    // eslint-disable-next-line
    open(title: string, message: string, options: any) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve({ confirm: true, selectedAssigneeRef: this.options.currentAssignee });
      this.dialog = false;
    },
    cancel() {
      this.resolve({ confirm: false, selectedAssigneeRef: "" });
      this.dialog = false;
    },
    hasAvatarImage(assigneeRef: string): boolean {
      const user = this.users.find((u: User) => {
        return u.id?.toString() === assigneeRef.toString();
      });
      if (user) {
        return user.avatarSmall !== null;
      }
      return false;
    },
    getAvatarName(assigneeRef: string): string {
      const user = this.users.find((u: User) => {
        return u?.id?.toString() === assigneeRef?.toString();
      });
      if (user && user.username) {
        return user.username;
      }
      return "";
    },
    getAvatarImage(assigneeRef: string): string {
      const user = this.users.find((u: User) => {
        return u.id?.toString() === assigneeRef.toString();
      });
      if (user) {
        return user.avatarSmall;
      }
      return "";
    },
    getAvatarAbbreviation(assigneeRef: string): string {
      const user = this.users.find((u: User) => {
        return u.id?.toString() === assigneeRef.toString();
      });
      if (user) {
        return user.username.substr(0, 2);
      }
      return "";
    },
  },
});

export default ConfirmDlgUser;
